import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'anamnese-corrida-iniciante',
    title: 'Anamnese de corredor iniciante',
    description: 'Colete histórico, objetivos e limitações de alunos que estão começando a correr com assessoria.',
    indicatedFor: 'Assessorias de corrida',
    stepsCount: 2,
    questionsSummary: ['Experiência com corrida', 'Lesões anteriores', 'Objetivo de prova', 'Rotina atual'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Anamnese de corredor iniciante',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Seu perfil de corredor',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Continuar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: 'Nome completo',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'scale',
                        label: 'Como você avalia sua experiência atual com a corrida?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Nunca corri',
                            maxLabel: 'Corro há anos',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 3,
                        type: 'choices',
                        label: 'Qual distância você deseja correr?',
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: '5 km' },
                                { id: 'opt-2', label: '10 km' },
                                { id: 'opt-3', label: 'Meia maratona (21 km)' },
                                { id: 'opt-4', label: 'Maratona (42 km)' },
                                { id: 'opt-5', label: 'Ainda não sei' },
                            ],
                        },
                    },
                ],
            },
            {
                order: 2,
                title: 'Saúde e histórico',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'yes_no_maybe',
                        label: 'Você já sofreu alguma lesão relacionada à corrida ou ao esporte?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: 'Descreva sua rotina atual de treinos ou atividades físicas.',
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'weight',
                        label: 'Seu peso atual',
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
};
